import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AccountTransaction } from '../types';

// Serializable version of AccountTransaction (Date -> string)
export type SerializableAccountTransaction = Omit<
  AccountTransaction,
  'transaction_date'
> & {
  transaction_date: string; // ISO string instead of Date
};

export interface TransactionsState {
  transactions: SerializableAccountTransaction[] | null;
}

const initialState: TransactionsState = {
  transactions: null,
};

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    setTransactions: (state, action: PayloadAction<SerializableAccountTransaction[]>) => {
      state.transactions = action.payload;
    },
    clearTransactions: (state) => {
      state.transactions = null;
    },
  },
});

export const { setTransactions, clearTransactions } = transactionsSlice.actions;

export default transactionsSlice;
